export const isEmptyJSON = (parsedJSON: any): boolean => {
    return Object.keys(parsedJSON).length === 0;
}